'use client'

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaTimes } from 'react-icons/fa'

const DisputeBanner = () => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    setIsVisible(false)
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className="relative bg-[#3E3B80] shadow-md flex flex-col sm:flex-row justify-center items-center py-2 mx-auto text-center text-white">
      <p className="text-center px-16">{t('disputeBannerText')}</p>
      <button
        onClick={handleClose}
        aria-label={t('close')}
        className="absolute top-0 right-0 mt-2 mr-2 text-lg font-bold text-white hover:text-gray-300"
      >
        <FaTimes />
      </button>
    </div>
  )
}

export default DisputeBanner
